<ng-container>
  <span mat-dialog-title>ADD PROJECT CREDITS</span>
  <div mat-dialog-content>
    <ng-container>
      <form [formGroup]="creditForm">
        <div class="row">
          <mat-form-field>
            <mat-label>Search project name...</mat-label>
            <input matInput formControlName="project" name="project" type="text">
          </mat-form-field>
        </div>
        <div class="row">
          <mat-form-field>
            <mat-select formControlName="fund_project_state">
              @for (state of projectStates; track state) {
                <mat-option [value]="state">{{state.name}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        @if (isLoading && searchResult.length == 0) {
          <div class="row"><mat-spinner diameter="30"></mat-spinner></div>
        }
        @if (searchResult.length > 0 && !isLoading) {
          <div class="row search-results">
            <table mat-table [multiTemplateDataRows]="true" [dataSource]="searchResult">
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>Project</th>
                <td mat-cell *matCellDef="let row">{{row.name}}</td>
              </ng-container>
              <ng-container matColumnDef="location">
                <th mat-header-cell *matHeaderCellDef>Location</th>
                <td mat-cell *matCellDef="let row">{{row.location}}</td>
              </ng-container>
              <ng-container matColumnDef="msa">
                <th mat-header-cell *matHeaderCellDef>MSA</th>
                <td mat-cell *matCellDef="let row">{{row.msa}}</td>
              </ng-container>
              <ng-container matColumnDef="yield">
                <th mat-header-cell *matHeaderCellDef>Yield %</th>
                <td mat-cell *matCellDef="let row">{{row.yieldVal | percent: '1.2-2'}}</td>
              </ng-container>
              <ng-container matColumnDef="innerTable">
                <td mat-cell *matCellDef="let row" [attr.colspan]="5">
                  <table mat-table [dataSource]="row.creditsForms">
                    <ng-container matColumnDef="check">
                      <th mat-header-cell *matHeaderCellDef></th>
                      <td mat-cell *matCellDef="let row" class="sub-table-data">
                        <mat-checkbox [formControl]="row.controls.selected" (change)="onSelected(row)"></mat-checkbox>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="type">
                      <th mat-header-cell *matHeaderCellDef>Type</th>
                      <td mat-cell *matCellDef="let row" class="sub-table-data">{{row.value.type}}</td>
                    </ng-container>
                    <ng-container matColumnDef="lt_equity">
                      <th mat-header-cell *matHeaderCellDef>LT Equity</th>
                      <td mat-cell *matCellDef="let row" class="sub-table-data">{{row.value.lt_equity | currency: 'USD':'symbol': '1.2-2'}}</td>
                    </ng-container>
                    <ng-container matColumnDef="ownership">
                      <th mat-header-cell *matHeaderCellDef>Ownership %</th>
                      <td mat-cell *matCellDef="let row" class="sub-table-data">
                        <mat-form-field>
                          <input matInput [formControl]="row.controls.ownership" name="ownership" type="number" (keyup)="onFieldChange(row)" (keydown)="onFieldChange(row)" (change)="onFieldChange(row)">
                        </mat-form-field>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="admitted_date">
                      <th mat-header-cell *matHeaderCellDef>Admitted Date</th>
                      <td mat-cell *matCellDef="let row" class="sub-table-data">
                        <mat-form-field>
                          <input matInput [matDatepicker]="admittedPicker" [formControl]="row.controls.admitted_date" (keyup)="onFieldChange(row)" (keydown)="onFieldChange(row)" (change)="onFieldChange(row)">
                          <mat-datepicker-toggle matSuffix [for]="admittedPicker"></mat-datepicker-toggle>
                          <mat-datepicker #admittedPicker></mat-datepicker>
                        </mat-form-field>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="is_target">
                      <th mat-header-cell *matHeaderCellDef>Target Date</th>
                      <td mat-cell *matCellDef="let row" class="sub-table-data">
                        <mat-checkbox [formControl]="row.controls.is_target"></mat-checkbox>
                      </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="creditLevelColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: creditLevelColumns"></tr>
                  </table>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="projectLevelColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: projectLevelColumns" class="project-table-row" [hidden]="row.creditsForms.length==0"></tr>
              <tr mat-row *matRowDef="let row; columns: ['innerTable']" [hidden]="row.creditsForms.length==0"></tr>
            </table>
          </div>
        }
      </form>
    </ng-container>
    <!--    <ng-container *ngIf="selectedCredits.length > 0">-->
    <!--      <div class="selected-credits">-->
    <!--        <div class="row">-->
    <!--          Selected Credits-->
  <!--        </div>-->
  <!--        <div *ngFor="let credit of selectedCredits">-->

<!--        </div>-->
<!--      </div>-->
<!--    </ng-container>-->
</div>
<div mat-dialog-actions>
  <button mat-raised-button (click)="save()">Save</button>
  <button mat-raised-button (click)="close()">Close</button>
</div>
</ng-container>
